import {BaseComponent, WmsMessageComponent, WmsSpinnerComponent} from '@wms/components';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from '@wms/components';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import {MixpanelService} from "@wms/app/services/mixpanel/mixpanel.service";

@Component({
  standalone: true,
  selector: 'wms-reimport-api',
  templateUrl: './reimport-api-confirmation.component.html',
  styleUrls: ['./reimport-api-confirmation.component.less'],
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    ButtonsModule,
    WmsSpinnerComponent,
  ]
})
export class ReimportApiConfirmationComponent extends BaseComponent {
  @Input() tagsCount: any;
  @Input() disableBtn: any;
  @Input() ws: any;
  @Input() reimportInProgress: boolean;

  @Output() reimportServiceapi = new EventEmitter<any>();
  constructor(private dialogService: DialogService, private mixpanelService: MixpanelService) {
    super();
  }
  closeReImportLoader(id: string): void {
    this.dialogService.close(id);
  }
  closeAllDialogs(): void {
    this.dialogService.closeAllDialogs();
  }
  reImportService() {
    this.mixpanelService.track('reimport_step2');
    this.reimportServiceapi.emit();
  }
  hasSwaggerName() {
    return this.ws.customServiceName ? false : true;
  }
}
